import { WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";

export function AgentOfflineBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Alert variant="destructive" className="my-2">
      <WifiOff className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <span>{t("inspectionChat.offline.banner")}</span>
        <Button variant="outline" size="sm" onClick={() => navigate("/inspections")}>
          {t("inspectionChat.offline.switchToUi")}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
